export const siteUrl = process.env.NODE_ENV === 'production'
  ? 'https://inspirationphotographers.com'
  : 'http://inspiration.test'
export const loginUrl = siteUrl + '/member-login/'
export const dashboardUrl = siteUrl + '/dashboard'

const base = siteUrl + '/wp-json'

export const validate = token =>
  fetch(`${base}/jwt-auth/v1/token/validate`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json'
    },
    credentials: 'omit'
  })
    .then(res => res.json()).then(result => {
      return new Promise((resolve, reject) => {
        if (result.data.status === 200) {
          resolve(result)
        } else {
          reject(result)
        }
      })
    })
    .catch(error => {
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })

export const getUser = () =>
  fetch(`${base}/member-dashboard/user`, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.token,
      'Content-Type': 'application/json'
    },
    credentials: 'omit'
  }).then(res => res.json())

export const updateUser = (params) =>
  fetch(`${base}/member-dashboard/user`, {
    method: 'PUT',
    headers: {
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.token,
      'Content-Type': 'application/json'
    },
    credentials: 'omit',
    body: JSON.stringify({
      params
    })
  }).then(res => res.json())

export const getSegments = () =>
  fetch(`${base}/member-dashboard/segments`, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.token,
      'Content-Type': 'application/json'
    },
    credentials: 'omit'
  }).then(res => res.json())

export const updateSegment = (id, params) =>
  fetch(`${base}/member-dashboard/segments/${id}`, {
    method: 'PUT',
    headers: {
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.token,
      'Content-Type': 'application/json'
    },
    credentials: 'omit',
    body: JSON.stringify(params)
  }).then(res => res.json())

export const uploadImages = (id, images) =>
  fetch(`${base}/member-dashboard/segments/${id}/upload`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.token,
      'Content-Type': 'application/json'
    },
    credentials: 'omit',
    body: JSON.stringify({
      images: images
    })
  }).then(res => res.json())
    .catch(error => error)

export const removeImage = (id, image) =>
  fetch(`${base}/member-dashboard/profiles/${id}/image/${image}`, {
    method: 'DELETE',
    headers: {
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.token,
      'Content-Type': 'application/json'
    },
    credentials: 'omit'
  }).then(res => res.json())
    .catch(error => error)

export const basicPlanPublish = id =>
  fetch(`${base}/member-dashboard/segments/${id}/basic-plan-publish`, {
    method: 'PUT',
    headers: {
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.token,
      'Content-Type': 'application/json'
    },
    credentials: 'omit',
  }).then(res => res.json())

export const pickFeaturedImage = (id, image) =>
  fetch(`${base}/member-dashboard/profiles/${id}/image/featured`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.token,
      'Content-Type': 'application/json'
    },
    credentials: 'omit',
    body: JSON.stringify({
      image
    })
  }).then(res => res.json())
    .catch(error => error)

export const membershipRequest = params =>
  fetch(`${base}/ip-api/membership-request`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.token,
      'Content-Type': 'application/json'
    },
    credentials: 'omit',
    body: JSON.stringify(params)
  }).then(res => res.json())
    .catch(error => error)

export const contact = params =>
  fetch(`${base}/member-dashboard/contact`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.token,
      'Content-Type': 'application/json'
    },
    credentials: 'omit',
    body: JSON.stringify(params)
  }).then(res => res.json())
    .catch(error => error)

export const submitPaypal = (postId) =>
  fetch(`${base}/member-dashboard/payment/paypal`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.token,
      'Content-Type': 'application/json'
    },
    credentials: 'omit',
    body: JSON.stringify({
      'post_id': postId
    })
  }).then(res => res.json())
    .catch(error => error)

export const submitStripe = async (currency, amount, finality) => {
  const res = await fetch(`${base}/member-dashboard/payment/stripe`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + localStorage.token,
      "Content-Type": "application/json",
    },
    credentials: "omit",
    body: JSON.stringify({
      finality,
      currency,
      amount,
      return_url: window.location.href, // <- importante
    }),
  });

  const { checkout_url } = await res.json();
  window.location.assign(checkout_url);
};

export const addVideo = (profileID, title, url, thumbnail) =>
  fetch(`${base}/member-dashboard/segments/${profileID}/video`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.token,
      'Content-Type': 'application/json'
    },
    credentials: 'omit',
    body: JSON.stringify({
      title,
      url,
      thumbnail
    })
  }).then(res => res.json())
    .catch(error => error)

export const removeVideo = (profileID, videoURL) =>
  fetch(`${base}/member-dashboard/segments/${profileID}/video`, {
    method: 'DELETE',
    headers: {
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.token,
      'Content-Type': 'application/json'
    },
    credentials: 'omit',
    body: JSON.stringify({
      videoURL
    })
  }).then(res => res.json())
    .catch(error => error)

export const submitAwards = (postId, awardsId, submission) => new Promise((resolve, reject) => {
  fetch(`${base}/member-dashboard/profile/${postId}/awards/${awardsId}`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.token,
      'Content-Type': 'application/json'
    },
    credentials: 'omit',
    body: JSON.stringify({
      submission
    })
  }).then(response => {
    if (response.ok) response.text().then(text => {
      try {
        const data = JSON.parse(text);
        resolve(data);
      } catch(err) {
        reject(err);
      }
    })
    else reject('HTTP response code = '+response.status)
  })
    .catch(error => {
    console.log('submitAwards catch');
    reject(error)
  })
})

export const registerAwards = (postId, awardsId, submission, admitComments) =>
  fetch(`${base}/member-dashboard/profile/${postId}/register_awards/${awardsId}`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.token,
      'Content-Type': 'application/json'
    },
    credentials: 'omit',
    body: JSON.stringify({
      submission,
      admitComments
    })
  }).then(res => res.json())
    .catch(error => error)

export const requestReview = (profileId, awardsId, submission_index) =>
  fetch(`${base}/member-dashboard/profile/${profileId}/awards/${awardsId}/request_review`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.token,
      'Content-Type': 'application/json'
    },
    credentials: 'omit',
    body: JSON.stringify({
      submission_index
    })
  }).then(res => res.json())
    .catch(error => error)

export const openADispute = (profileId, awardsId, submission_index, message) =>
  fetch(`${base}/member-dashboard/profile/${profileId}/awards/${awardsId}/open_a_dispute`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.token,
      'Content-Type': 'application/json'
    },
    credentials: 'omit',
    body: JSON.stringify({
      submission_index,
      message
    })
  }).then(res => res.json())
    .catch(error => error)

export const getMediaURLbyID = id =>
  fetch(`${base}/wp/v2/media/${id}`, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.token,
      'Content-Type': 'application/json'
    },
    credentials: 'omit'
  }).then(res => res.json())
    .then(image => image)
    .catch(error => error)
